export default __webpack_public_path__ + "static/media/icn-small-alert.ab836977.svg";